import { Component } from '@angular/core';

@Component({
    selector: 'app-not-authorized',
    templateUrl: './app-not-authorized.cmp.html',
    styleUrls: [ './fullscreen-message.scss' ],
})
export class AppNotAuthorized {}
